export default "__VITE_ASSET__B27shezb__"